import React from 'react';
    const loans = [
        {
        "type": "Total Outstanding",
        "amount": "00,000"
        },
        {
        "type": "Home Loan",
        "amount": "00,000"
        },
        {
        "type": "Credit Cards",
        "amount": "00,000"
        },
        {
        "type": "Personal Loan",
        "amount": "00,000"
        },
        {
        "type": "Vehicle Loan",
        "amount": "00,000"
        },
        {
        "type": "Other Loan",
        "amount": "00,000"
        }
    ];

const TotalAccounts = () => {
    return (
    <div className='flex flex-col justify-center items-center h-fit w-full my-5'>
        <div className='flex flex-row w-[90%] justify-center items-center gap-4 lg:gap-0'>
            <div className='flex flex-col justify-center items-start w-[48%] lg:w-[40%] gap-2'>
                <p className='text-red-500 text-xl lg:text-2xl font-semibold'>Loan EMI - 9,900.6</p>
                <p className='text-md lg:text-lg'>Interest Amount - 94,036</p>
            </div>
            <div className='flex flex-col justify-center items-start w-[48%] lg:w-[40%] gap-2'>
                <p className='text-sm lg:text-lg'>Loan Amount - 5,00,000</p>
                <p className='text-sm lg:text-lg'>Total Amount Payable- 5,94,036.0</p>
            </div>
        </div>
        <div className='flex flex-row w-[95%] lg:w-[90%] justify-center mt-3'>
            {
            loans.map((value,index)=>{
                return <div key={index} className='flex flex-col justify-around items-start w-[20%] p-1 lg:p-2 border border-primary rounded-lg m-1 lg:m-2'>
                    <p className='text-xs lg:text-md'>{value.amount}/-</p>
                    <p className='text-xs lg:text-sm text-gray-500'>{value.type}</p>
                </div>
            })
            }
        </div>
    </div>
    )
}

export default TotalAccounts